import { useState } from 'react';

interface ID20IconButton {
  onClick: () => void;
}

export const D20IconButton: React.FC<ID20IconButton> = ({ onClick }) => {
  const defaultPurple = '#de84b7';
  const highlightColour = '#e59dc5';
  const [colour, setColour] = useState(defaultPurple);

  return (
    <button
      className="btn btn-link"
      onMouseEnter={() => setColour(highlightColour)}
      onMouseLeave={() => setColour(defaultPurple)}
      onClick={() => onClick()}
    >
      <svg
        width="24"
        height="24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            style={{
              color: '#000000',
              fill: colour,
              strokeLinejoin: 'round',
              strokeWidth: 3.77,
            }}
            d="M 9.6110029,1.3811546 A 0.50005004,0.50005004 0 0 0 9.1090343,1.5066468 L 1.2694665,9.4052697 A 0.50005004,0.50005004 0 0 0 1.1513562,9.9220023 L 4.9087387,21.105566 a 0.50005004,0.50005004 0 0 0 0.4133858,0.332187 l 9.1683085,1.203248 a 0.50005004,0.50005004 0 0 0 0.39124,-0.11811 l 7.846949,-6.806105 A 0.50005004,0.50005004 0 0 0 22.87626,15.177908 L 19.340335,4.5406037 A 0.50005004,0.50005004 0 0 0 19.015533,4.2231838 Z m 0,1.0408466 8.8656501,2.6796262 3.351379,10.0762806 -7.433564,6.437009 L 5.7576558,20.485487 2.1995847,9.8924747 Z"
            id="path12"
          />
          <path
            style={{
              color: '#000000',
              fill: colour,
              strokeLinejoin: 'round',
              strokeWidth: 3.77,
            }}
            d="m 9.2492903,1.8314499 -0.073819,0.3174213 -1.8602365,8.3193908 -0.00738,-0.0074 -0.044291,0.221457 L 1.5130712,9.4864526 1.6533272,9.8998385 5.2335441,20.529761 5.1892521,20.7586 h 0.1254916 l 0.2676738,0.544006 0.1161864,-0.551388 10.7701781,-0.110729 0.19931,0.206691 0.05167,-0.206691 0.211819,-0.101733 -0.13062,-0.208294 3.211122,-12.4384853 0.362351,-0.1176265 -0.281148,-0.2145562 0.05905,-0.2214577 -0.317419,0.081199 z M 9.5888571,2.5770209 19.118878,7.6114702 7.7876758,10.630664 Z M 19.458445,8.0470019 16.402342,19.858027 8.7325578,11.94464 7.9353136,11.110487 Z m -17.1924233,2.1112211 4.8868117,1.0187 -0.029528,0.147638 h 0.00737 l -1.6978233,8.230808 z m 5.3371069,1.336122 8.3267724,8.651576 -10.1279537,0.103346 z"
            id="path16"
          />
          <path
            style={{
              color: '#000000',
              fill: colour,
              strokeLinejoin: 'round',
              strokeWidth: 3.77,
            }}
            d="M 15.163413,7.9233096 C 14.104412,6.9334063 13.366762,6.7716825 12.812464,6.7716825 c -0.03943,0 -0.07722,0.00234 -0.113363,0.00703 -0.54672,0.067248 -1.085005,0.9180009 -1.525835,1.9860766 -0.769797,-1.6685713 -1.029694,-3.5201541 -0.868709,-4.9885627 1.974267,1.2682422 3.442613,2.5457548 4.85886,4.1470863 z"
            id="text16"
            aria-label="A"
          />
        </g>
      </svg>
    </button>
  );
};
